import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ChangePasswordService } from './change-password.service';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule]
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm: FormGroup;
  isLoading = false;
  errorMessage: string | null = null;
  successMessage: string | null = null;
  username: string | null = null;
  showConfirmPassword: boolean = false;
  showNewPassword:boolean =  false; // now only internal — no input field

  constructor(
    private fb: FormBuilder,
    private changePasswordService: ChangePasswordService,
    private router: Router,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService,
    private sessionStorageService: SessionStorageService
  ) {
    this.changePasswordForm = this.fb.group(
      {
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
            ),
          ],
        ],
        confirmPassword: ['', Validators.required],
      },
      { validators: this.passwordMatchValidator }
    );
  }

  ngOnInit(): void {
    // 🔹 Try to get username from query params first
    this.route.queryParams.subscribe((params) => {
      this.username = params['username'] || null;

      // If not in params, fall back to sessionStorage (saved from SigninComponent)
      if (!this.username) {
        this.username = this.sessionStorageService.retrieve('tempUsername') || null;
      }
    });
  }

  passwordMatchValidator(form: FormGroup) {
    return form.get('password')?.value === form.get('confirmPassword')?.value
      ? null
      : { notSame: true };
  }

  onSubmit(): void {
    if (this.changePasswordForm.invalid || !this.username) {
      return;
    }

    this.isLoading = true;
    this.errorMessage = null;
    this.successMessage = null;

    const token =
      this.localStorageService.retrieve('authenticationToken') ??
      this.sessionStorageService.retrieve('authenticationToken');

    const newPassword = this.changePasswordForm.get('password')!.value;

    // 🔹 Use internal username captured from SigninComponent
    this.changePasswordService
      .changePassword(this.username, newPassword, token)
      .subscribe({
        next: () => {
          this.isLoading = false;
          this.successMessage =
            'Password changed successfully. Please log in with your new password.';
          setTimeout(() => {
            this.router.navigate(['/signin']);
          }, 2000);
        },
        error: (err) => {
          this.isLoading = false;
          this.errorMessage =
            err.error?.message || 'Failed to change password. Please try again.';
        },
      });
  }
  

toggleConfirmPassword() {
  this.showConfirmPassword = !this.showConfirmPassword;
}


toggleNewPassword() {
  this.showNewPassword = !this.showNewPassword;
}


}
